import ColorPicker from '../picker/ColorPicker';

const STYLE_DEFAULTS = {
  default: {
    background_color: '#0f1419',
    surface_color: '#1a2332',
    card_color: '#232f42',
    accent_color: '#22c55e',
    accent_hover_color: '#16a34a',
    text_color: '#f1f5f9',
    text_muted_color: '#94a3b8',
    border_color: 'rgba(255, 255, 255, 0.08)',
    highlight_color: '#f59e0b',
    border_radius: 16,
    border_radius_sm: 10,
    font_family: "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  modern: {
    background_color: '#f0f4ff',
    surface_color: 'rgba(255, 255, 255, 0.75)',
    card_color: '#ffffff',
    accent_color: '#6366f1',
    accent_hover_color: '#4f46e5',
    text_color: '#0f172a',
    text_muted_color: '#64748b',
    border_color: 'rgba(99, 102, 241, 0.14)',
    highlight_color: '#ec4899',
    border_radius: 24,
    border_radius_sm: 14,
    font_family: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  pizza: {
    background_color: '#1a0a05',
    surface_color: '#2d1810',
    card_color: '#3d2318',
    accent_color: '#c41e3a',
    accent_hover_color: '#9a1830',
    text_color: '#fff8e7',
    text_muted_color: '#d4c4a8',
    border_color: 'rgba(244, 160, 32, 0.22)',
    highlight_color: '#f4a020',
    border_radius: 12,
    border_radius_sm: 8,
    font_family: "'Playfair Display', 'Georgia', 'Times New Roman', serif",
  },
  tropical: {
    background_color: '#e0f7fa',
    surface_color: 'rgba(255, 255, 255, 0.88)',
    card_color: 'rgba(255, 255, 255, 0.95)',
    accent_color: '#00bcd4',
    accent_hover_color: '#0097a7',
    text_color: '#1a4a5e',
    text_muted_color: '#4a7a8c',
    border_color: 'rgba(0, 188, 212, 0.2)',
    highlight_color: '#ff7043',
    border_radius: 20,
    border_radius_sm: 12,
    font_family: "'Quicksand', 'Nunito', 'Poppins', sans-serif",
  },
  street: {
    background_color: '#1a1a1a',
    surface_color: '#252525',
    card_color: '#2e2e2e',
    accent_color: '#ffc107',
    accent_hover_color: '#ffb300',
    text_color: '#ffffff',
    text_muted_color: '#aaaaaa',
    border_color: 'rgba(255, 193, 7, 0.22)',
    highlight_color: '#e53935',
    border_radius: 8,
    border_radius_sm: 6,
    font_family: "'Bebas Neue', 'Impact', 'Arial Narrow', sans-serif",
  },
  patisserie: {
    background_color: '#faf7f2',
    surface_color: '#fff9f5',
    card_color: '#ffffff',
    accent_color: '#d4a574',
    accent_hover_color: '#c49563',
    text_color: '#3d2b1f',
    text_muted_color: '#8b7355',
    border_color: 'rgba(212, 165, 116, 0.35)',
    highlight_color: '#e8b4b8',
    border_radius: 20,
    border_radius_sm: 12,
    font_family: "'Cormorant Garamond', 'Georgia', serif",
  },
  prestige: {
    background_color: '#0a0a0a',
    surface_color: '#141414',
    card_color: '#1a1a1a',
    accent_color: '#c9a962',
    accent_hover_color: '#b8944d',
    text_color: '#f5f0e6',
    text_muted_color: '#8a8272',
    border_color: 'rgba(201, 169, 98, 0.28)',
    highlight_color: '#c9a962',
    border_radius: 4,
    border_radius_sm: 2,
    font_family: "'Cormorant', 'Garamond', 'Times New Roman', serif",
  },
  neon: {
    background_color: '#0d0221',
    surface_color: '#1a0533',
    card_color: '#240846',
    accent_color: '#00ffff',
    accent_hover_color: '#00cccc',
    text_color: '#e0e0ff',
    text_muted_color: '#9070c0',
    border_color: 'rgba(0, 255, 255, 0.35)',
    highlight_color: '#ff00ff',
    border_radius: 4,
    border_radius_sm: 2,
    font_family: "'Orbitron', 'Rajdhani', monospace",
  },
  minimal: {
    background_color: '#ffffff',
    surface_color: '#f8f9fa',
    card_color: '#ffffff',
    accent_color: '#2563eb',
    accent_hover_color: '#1d4ed8',
    text_color: '#111827',
    text_muted_color: '#6b7280',
    border_color: '#e5e7eb',
    highlight_color: '#2563eb',
    border_radius: 8,
    border_radius_sm: 6,
    font_family: "system-ui, -apple-system, 'Segoe UI', sans-serif",
  },
  latino: {
    background_color: '#1c0c08',
    surface_color: 'rgba(62, 24, 14, 0.9)',
    card_color: '#3a1c14',
    accent_color: '#f25c2a',
    accent_hover_color: '#d44518',
    text_color: '#fff4e6',
    text_muted_color: '#e0b896',
    border_color: 'rgba(246, 196, 69, 0.28)',
    highlight_color: '#f6c445',
    border_radius: 18,
    border_radius_sm: 12,
    font_family: "'Fraunces', 'Nunito', Georgia, serif",
  },
  demo: {
    background_color: '#0b1020',
    surface_color: 'rgba(18, 24, 42, 0.72)',
    card_color: 'rgba(28, 36, 58, 0.88)',
    accent_color: '#7c8cff',
    accent_hover_color: '#6366f1',
    text_color: '#f4f6fb',
    text_muted_color: '#9aa3b8',
    border_color: 'rgba(255, 255, 255, 0.12)',
    highlight_color: '#5eead4',
    border_radius: 22,
    border_radius_sm: 14,
    font_family: "'Outfit', 'Manrope', system-ui, sans-serif",
  },
};

export default function CommandCellProperties({ cell, onChange }) {
  const styles = cell.styles_properties || {};
  const cellApiId = cell.cell_id || cell.id;
  const templateDefaults = STYLE_DEFAULTS[cell.template_name || 'default'] || STYLE_DEFAULTS.default;

  const updateStyle = (key, value) => {
    onChange(cellApiId, {
      styles_properties: { ...styles, [key]: value },
      type: cell.type,
    });
  };

  return (
    <div className="property-section">
      <div className="property-section-title">Commande (borne)</div>

      <div className="property-row">
        <div className="property-label">Template</div>
        <select
          className="property-input property-input-small"
          value={cell.template_name || 'default'}
          onChange={(e) =>
            onChange(cellApiId, { template_name: e.target.value, type: cell.type })
          }
        >
          <option value="default">Par défaut</option>
          <option value="modern">Moderne</option>
          <option value="pizza">Pizza</option>
          <option value="tropical">Tropical</option>
          <option value="street">Street food</option>
          <option value="patisserie">Pâtisserie</option>
          <option value="prestige">Prestige</option>
          <option value="neon">Néon</option>
          <option value="minimal">Minimal</option>
          <option value="demo">Démo</option>
          <option value="latino">Latino</option>
        </select>
      </div>

      <div className="property-section-title">Paiement</div>
      <div className="property-row">
        <div className="property-label">Fournisseur</div>
        <select
          className="property-input property-input-small"
          value={styles.payment_provider || 'stripe'}
          onChange={(e) => updateStyle('payment_provider', e.target.value)}
        >
          <option value="stripe">Stripe (QR / terminal natif)</option>
          <option value="newcactus">New Cactus (caisse RRA)</option>
        </select>
      </div>
      {styles.payment_provider === 'newcactus' && (
        <>
          <p className="property-hint" style={{ margin: '0 0 8px', fontSize: '0.8rem', opacity: 0.85 }}>
            Le catalogue est chargé depuis l&apos;API New Cactus (GET /menu). Les produits CMS ne sont pas utilisés.
            Sur l&apos;app native Android, l&apos;option <strong>Carte (WisePad)</strong> apparaît automatiquement
            (Stripe Terminal + commande New Cactus).
          </p>
          <div className="property-row">
            <div className="property-label">Méthode par défaut</div>
            <select
              className="property-input property-input-small"
              value={styles.newcactus_payment_method || 'cash'}
              onChange={(e) => updateStyle('newcactus_payment_method', e.target.value)}
            >
            <option value="cash">Espèces</option>
            <option value="stripe_wisepad">Carte WisePad (app native)</option>
            <option value="terminal">Terminal New Cactus</option>
              <option value="momo">MTN MoMo</option>
              <option value="airtel">Airtel Money</option>
              <option value="online">QR en ligne</option>
              <option value="card">Carte</option>
            </select>
          </div>
        </>
      )}

      <div className="property-section-title">Couleurs</div>
      <div className="property-row">
        <div className="property-label">Fond</div>
        <ColorPicker
          value={styles.background_color || templateDefaults.background_color}
          onChange={(color) => updateStyle('background_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Surface (header, panier)</div>
        <ColorPicker
          value={styles.surface_color || templateDefaults.surface_color}
          onChange={(color) => updateStyle('surface_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Cartes</div>
        <ColorPicker
          value={styles.card_color || templateDefaults.card_color}
          onChange={(color) => updateStyle('card_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Accent (boutons, prix)</div>
        <ColorPicker
          value={styles.accent_color || templateDefaults.accent_color}
          onChange={(color) => updateStyle('accent_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Accent au survol</div>
        <ColorPicker
          value={styles.accent_hover_color || templateDefaults.accent_hover_color}
          onChange={(color) => updateStyle('accent_hover_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Texte</div>
        <ColorPicker
          value={styles.text_color || templateDefaults.text_color}
          onChange={(color) => updateStyle('text_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Texte secondaire</div>
        <ColorPicker
          value={styles.text_muted_color || templateDefaults.text_muted_color}
          onChange={(color) => updateStyle('text_muted_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Bordures</div>
        <ColorPicker
          value={styles.border_color || templateDefaults.border_color}
          onChange={(color) => updateStyle('border_color', color)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Mise en avant</div>
        <ColorPicker
          value={styles.highlight_color || templateDefaults.highlight_color}
          onChange={(color) => updateStyle('highlight_color', color)}
        />
      </div>

      <div className="property-section-title">Typographie et formes</div>
      <div className="property-row">
        <div className="property-label">Police</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder={templateDefaults.font_family}
          value={styles.font_family || ''}
          onChange={(e) => updateStyle('font_family', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Rayon des bordures (px)</div>
        <input
          className="property-input property-input-small"
          type="number"
          min={0}
          value={styles.border_radius ?? templateDefaults.border_radius}
          onChange={(e) => updateStyle('border_radius', parseInt(e.target.value, 10) || 0)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Rayon petit (px)</div>
        <input
          className="property-input property-input-small"
          type="number"
          min={0}
          value={styles.border_radius_sm ?? templateDefaults.border_radius_sm}
          onChange={(e) => updateStyle('border_radius_sm', parseInt(e.target.value, 10) || 0)}
        />
      </div>

      <div className="property-section-title">Textes</div>
      <div className="property-row">
        <div className="property-label">Titre mode de consommation</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Comment souhaitez-vous déguster ?"
          value={styles.consumption_title || ''}
          onChange={(e) => updateStyle('consumption_title', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Libellé sur place</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Sur place"
          value={styles.on_site_label || ''}
          onChange={(e) => updateStyle('on_site_label', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Libellé à emporter</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="À emporter"
          value={styles.takeaway_label || ''}
          onChange={(e) => updateStyle('takeaway_label', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Titre catalogue produits</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Commandez"
          value={styles.products_title || ''}
          onChange={(e) => updateStyle('products_title', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Titre panier</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Votre commande"
          value={styles.cart_title || ''}
          onChange={(e) => updateStyle('cart_title', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Bouton ajouter au panier</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Ajouter"
          value={styles.add_to_cart_label || ''}
          onChange={(e) => updateStyle('add_to_cart_label', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Préfixe validation commande</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Valider la commande"
          value={styles.validate_order_prefix || ''}
          onChange={(e) => updateStyle('validate_order_prefix', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Titre récapitulatif</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Récapitulatif"
          value={styles.recap_title || ''}
          onChange={(e) => updateStyle('recap_title', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Titre QR code</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Scannez le QR code pour payer"
          value={styles.qr_code_title || ''}
          onChange={(e) => updateStyle('qr_code_title', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Titre paiement accepté</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Paiement accepté"
          value={styles.payment_success_title || ''}
          onChange={(e) => updateStyle('payment_success_title', e.target.value)}
        />
      </div>
      <div className="property-row">
        <div className="property-label">Bouton nouvelle commande</div>
        <input
          className="property-input property-input-small"
          type="text"
          placeholder="Nouvelle commande"
          value={styles.new_order_label || ''}
          onChange={(e) => updateStyle('new_order_label', e.target.value)}
        />
      </div>
    </div>
  );
}
